export default __webpack_public_path__ + "static/media/panOregano.4a618af2.png";